/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { filesGetUploadUrl } from "../funcs/filesGetUploadUrl.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import * as operations from "../models/operations/index.js";
import { unwrapAsync } from "../types/fp.js";

export class Files extends ClientSDK {
    /**
     * Upload any files to the storage
     *
     * @remarks
     * Usually when you run something, you want to upload a file, image etc.
     */
    async getUploadUrl(
        request: operations.GetUploadUrlRequest,
        options?: RequestOptions
    ): Promise<operations.GetUploadUrlResponseBody> {
        return unwrapAsync(filesGetUploadUrl(this, request, options));
    }
}
